import e from "react";
import { u as m, D as l } from "./DarkModeProvider-xoZXm3ct.es.js";
import { I as i } from "./Icon-ByeAHRM4.es.js";
import { T as d } from "./Tooltip-CwfAdzNQ.es.js";
import { T as p } from "./index-BB-Wk85r.es.js";
import './Icon3.css';const f = "Icon-module__container___yvffm", u = {
  container: f
}, I = ({
  name: r,
  label: o,
  color: a,
  altColor: n,
  backgroundColor: s,
  tooltipStyles: c = {}
}) => {
  const t = m();
  return /* @__PURE__ */ e.createElement(
    d.Hover,
    {
      dark: !t,
      trigger: /* @__PURE__ */ e.createElement("div", { style: { backgroundColor: s }, className: u.container }, /* @__PURE__ */ e.createElement(
        i,
        {
          name: r,
          color: a,
          alt_color: n,
          size: "1.25rem"
        }
      )),
      placement: "left",
      accessible: !0,
      short: !0
    },
    /* @__PURE__ */ e.createElement(l, { darkMode: !t }, /* @__PURE__ */ e.createElement("div", { style: c }, /* @__PURE__ */ e.createElement(p.Body2, { responsive: !0 }, o)))
  );
};
export {
  I
};
